import BaseLayer from "./BaseLayer";
import {plotDisagreementsHelper} from "../utils/map_utils";

class StitchPreRound3Disagreementv2 extends BaseLayer {

    id = "stitchPreRound3Disagreementv2";
    label = "Before";
    defaultVisible = this.props.tileViewerState[this.id];

    draw = () => new Promise((resolve, reject) => {
        let {stitchPreR3Disagreement, textColor} = this.props;
        plotDisagreementsHelper(stitchPreR3Disagreement.result, this.props.slide, this.layer.getSource(), textColor);
        resolve();
    });
}

export default StitchPreRound3Disagreementv2;
